var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.609,
    height: 37.479,
    viewBox: "0 0 28.609 37.479",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "education-graduate-graduation-cap-svgrepo-com",
    transform: "translate(-18 -3.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70",
    transform: "translate(4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M19.864,10.153l4.687,2.061a8.15,8.15,0,0,0-1.414,4.607,8.243,8.243,0,1,0,15.113-4.566l4.122-1.94v7.839L41.118,20.82a.562.562,0,0,0,.04.566.691.691,0,0,0,.525.283h2.384a.49.49,0,0,0,.485-.283.562.562,0,0,0,.04-.566L43.5,18.153V9.789c0-.323-.04-.566-.606-.808-.121-.04-11.233-4.97-11.233-4.97a.515.515,0,0,0-.485,0L19.864,9.021a.634.634,0,0,0-.364.566A.609.609,0,0,0,19.864,10.153ZM38.371,16.82a7.031,7.031,0,0,1-14.062,0A7.161,7.161,0,0,1,25.642,12.7l5.5,2.465a.748.748,0,0,0,.485,0l5.415-2.424A6.849,6.849,0,0,1,38.371,16.82Zm4.243,3.637.283-.606.242.606ZM31.42,5.223,41.24,9.587,31.42,13.951,21.6,9.587Z",
    transform: "translate(-3.278 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M28.3,59.8A14.331,14.331,0,0,0,14,74.1a.621.621,0,0,0,.606.606H42a.621.621,0,0,0,.606-.606A14.331,14.331,0,0,0,28.3,59.8ZM15.253,73.5a13.086,13.086,0,0,1,26.144,0Z",
    transform: "translate(0 -33.282)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent);
export default __webpack_public_path__ + "static/media/student.2d285b044a95f3ac99e83cf790dd9bb7.svg";
export { ForwardRef as ReactComponent };